<template>
  <nav class="tabs">
    <ul class="tabs__list">
      <li class="tabs__elem">
        <a :class="['tab-btn', codeactivesection===null && currentTab===null? 'active' : '']"
           href="/its-time-to/" style="text-decoration: none;"><span class="tab-btn__name">Все новости</span></a>
      </li>
      <li v-for="(section, index) in resultSection"
          :key="index"
          class="tabs__elem">
        <a @click="updateURL(section.SECTION_PAGE_URL), currentTab = section.CODE, autoScroll($event.target)"
           v-on:click.prevent
           :class="['tab-btn', codeactivesection === section.CODE && currentTab===null? 'active': '', { active: currentTab === section.CODE } ]"
           :href="section.SECTION_PAGE_URL"
            style="text-decoration: none;">

          <img class="tab-btn__svg"
               :src="section.UF_ICON">
          <span class="tab-btn__name">{{ section.NAME }}</span>
        </a>
      </li>
      <li v-for="(section, index) in sectionsgroup"
          :key="index"
          class="tabs__elem">
        <a :class="['tab-btn',section.CODE.forEach(elem =>  {if(elem === codeactivesection) {clickGroupButton = true}}), clickGroupButton && currentTab===null? 'active': '' ]"
           :href="section.SECTION_PAGE_URL">

          <img class="tab-btn__svg"
               :src="section.UF_ICON">
          <span class="tab-btn__name">{{ section.NAME }}</span>
        </a>
      </li>

    </ul>
  </nav>
  <div v-if="clickGroupButton && currentTab===null"
       class="info-list__options">
    <a v-for="(section, index) in resultSectionGroup"
       :key="index"
       :class="['option', codeactivesection === section.CODE? 'active': '' ]"
       :href="section.SECTION_PAGE_URL"
       style="text-decoration: none;">{{ section.NAME }}</a>
    <!--    <button class="option" type="button">Новости компании</button>-->
  </div>
</template>

<script>
export default {
  data()
    {
      return {
        clickGroupButton : false,
        currentTab       : null
      };

    },
  name     : "ItstimeSectionList",
  props    : {
    codeactivesection : {
      type     : String,
      default  : null,
      required : false
    },

    sections : {
      type     : Array,
      required : true
    },

    sectionsgroup : {
      type     : Array,
      required : true
    },

    theme :
        {
          type     : String,
          required : true
        }
  },
  computed : {
    resultSection()
      {
        return this.sections.filter(item => ( item.UF_THEME[ 0 ] === this.theme || item.UF_THEME[ 1 ] === this.theme ));
        //return localStorage.getItem('color-scheme');
      },
    resultSectionGroup()
      {
        let data=this.sectionsgroup[ 0 ].ELEMENTS;
        //console.log(data);
        //return data;
        return data.filter(item => ( item.UF_THEME[ 0 ] === this.theme || item.UF_THEME[ 1 ] === this.theme ));
        //return localStorage.getItem('color-scheme');
      }

  },
  mounted()
    {
      document.querySelector(".page").classList.remove("page_collection-tastes");
      document.querySelector(".page").classList.add("page_info");

      let btnCollection = document.querySelectorAll('.tab-btn');
      let activeElement;
      btnCollection.forEach(e => {if(e.classList.contains('active')) {activeElement = e}})
      // activeElement.scrollIntoView({ block: "end", inline: "nearest"});

      let navs = document.querySelector('.tabs__list');

      let xPos = activeElement.getBoundingClientRect().x;

      //console.log(xPos);

      if(xPos < navs.scrollWidth/2)
        {
          navs.scrollTo(xPos - (navs.offsetWidth)/2  + activeElement.offsetWidth/4, 0);
        }
      else
        {
          navs.scrollTo(xPos - (navs.offsetWidth)/2 + activeElement.offsetWidth/4, 0);
        }


      //console.log(navs.scrollWidth);


      let sectionTheme = this.sections.filter(section => (section.CODE === this.codeactivesection));
      console.log(sectionTheme);
      if(sectionTheme.length > 0)
        {
          sectionTheme = sectionTheme[0].UF_THEME;
          // console.log(sectionTheme[0]);
          // console.log(localStorage.getItem('color-scheme'));
          if(sectionTheme.length === 1)
            {
              if(localStorage.getItem('color-scheme') !== sectionTheme[0])
                {
                  localStorage.setItem('color-scheme', sectionTheme[0]);
                  document.cookie = "theme="+sectionTheme[0] + "; path=/; max-age=86400;";
                  // console.log('!');
                }

            }
        }

    },
  methods :
      {
        updateURL( url )
          {
            if( history.pushState )
              {
                let baseUrl=window.location.protocol + "//" + window.location.host;
                let newUrl =baseUrl + url;
                history.pushState(null, null, newUrl);

                let data=new FormData();
                data.set("ajax_get_page", "Y");
                fetch(newUrl, {
                  method : "POST",
                  body   : data
                })
                    .then(response => response.text())
                    .then(result =>
                    {
                      document.querySelector(".info-list__content").innerHTML = "";
                      document.querySelector(".info-list__content").insertAdjacentHTML("beforeend", result);

                    });
                setTimeout(() =>
                {
                  //window.initUI();
                  window.dropdown();
                  window.copyonClick();
                }, 250);
              }
            else
              {
                console.warn("History API не поддерживает ваш браузер");
              }

            let data=new FormData();

            data.set("ajax_get_page", "Y");

            // let btnCollection = document.querySelectorAll('.tab-btn');
            // let activeElement;
            // btnCollection.forEach(e => {if(e.classList.contains('active')) {activeElement = e}})
            //
            // let navs = document.querySelector('.tabs__list');
            //
            // let xPos = activeElement.getBoundingClientRect().x;
            //
            // console.log(xPos);
            // navs.scrollTo(xPos, 0);


          },
        autoScroll(element )
          {
            let link = element.closest('a');
            // let xPos = link.getBoundingClientRect().x;
            // let halfWidthElement = link.getBoundingClientRect().width/2;
            // let halfWidthWindow = window.innerWidth/2;
            // console.log(xPos, halfWidthWindow);
            // console.log(link.getBoundingClientRect());
            // if(xPos < halfWidthWindow)
            //   {
            //     document.querySelector('.tabs__list').scrollBy(-(halfWidthWindow - xPos) + halfWidthElement, 0);
            //   }
            // else
            //   {
            //     document.querySelector('.tabs__list').scrollBy((xPos - halfWidthWindow) + halfWidthElement, 0);

            //   }
            // document.querySelector('.tabs__list').scrollTo(link.getBoundingClientRect().x, 0);
            link.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"});
          }
      },

};
</script>

<style scoped>

</style>